import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectKubun
 */
class SelectKubun extends React.Component {

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedKubun();
  }

  render() {
    const actions = this.props.actions;
    let itemList = [];

    // 表示データを取得
    if (this.props.data.pskubun == null || this.props.data.pskubun === '') {
      itemList = this.props.data.itemList.kubunList['allList'];
    } else if (this.props.data.pskubun === '1') {
      itemList = this.props.data.itemList.kubunList['slotList'];
    } else {
      itemList = this.props.data.itemList.kubunList['pachinkoList'];
    }

    const nodes = itemList.map((item) => {
      return (
        <option value={item.id} key={item.id}>
          {item.display_name}
        </option>
      );
    });
    const kubun = this.props.data.kubun;

    return (
      <div>
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable"><p>地域・区分</p></div>
        <label className="select">
          <select name="pw_extraction_02" id="selectKubun" value={kubun} onChange={e => actions.changeKubun(e.target.value)}>
            {nodes}
          </select>
        </label>
      </div>
    );
  }
}

SelectKubun.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectKubun;
